import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import type { NavigationRoutesFn } from 'modules/core/lib/react-router'

const ContractVersionsPage = React.lazy(
  () => import('modules/contracts/pages/ContractVersionsPage')
)
const IndexPage = React.lazy(() => import('modules/contracts/pages/profile/IndexPage'))
const RootPage = React.lazy(() => import('modules/contracts/pages/profile/RootPage'))

const profileRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.profile.contractVersions.path,
      element: <RootPage />,
      handle: {
        meta: () => ({
          title: i18n.t('admin_employee.contracts'),
        }),
      },
      children: [
        {
          index: true,
          element: <IndexPage />,
        },
        {
          path: navigation.profile.contractVersions.contractVersionId.path,
          element: <ContractVersionsPage />,
        },
      ],
    },
  ]
}

export default profileRoutes
